import { useRef, useCallback } from 'react';
import {
  SearchBarFilters,
  ESearchBarStatus,
  getEffectiveSearchFilters,
  toSearchDetailDTO,
} from '../Context/types';
import { useSearchBarContext } from '../Context/SearchBarContext';
import SearchService from 'business/services/SearchService';

export const useExplorerSearch = () => {
  const { mode, recordRecentSearch, updateExplorerSearch } = useSearchBarContext();
  const explorerRequestIdRef = useRef(0);
  const explorerAbortControllerRef = useRef<AbortController | null>(null);
  const searchService = new SearchService();

  const handleSearch = useCallback(
    async (searchFilters: SearchBarFilters) => {
      explorerAbortControllerRef.current?.abort();
      const abortController = new AbortController();
      explorerAbortControllerRef.current = abortController;
      const requestId = ++explorerRequestIdRef.current;
      updateExplorerSearch(ESearchBarStatus.Loading, undefined, mode);
      const effectiveFilters = getEffectiveSearchFilters(searchFilters, mode);
      const searchDetail = toSearchDetailDTO(effectiveFilters);
      recordRecentSearch(searchDetail);
      searchService.RecordRecentSearch(searchDetail).catch(() => {});
      try {
        const results = await searchService.SearchWithFilters(
          effectiveFilters,
          undefined,
          abortController.signal,
        );
        if (requestId !== explorerRequestIdRef.current) {
          return;
        }
        updateExplorerSearch(
          results.length > 0 ? ESearchBarStatus.Finished : ESearchBarStatus.NoResults,
          results,
          mode,
        );
      } catch {
        if (requestId !== explorerRequestIdRef.current) {
          return;
        }
        updateExplorerSearch(ESearchBarStatus.NoResults, [], mode);
      }
    },
    [mode, updateExplorerSearch, recordRecentSearch],
  );

  return { handleSearch };
};
